import DEFAULT_PRICING_ALGORITHM from '../constants/defaultPriceAlgorithm';
import {unitPriceDisplayTestFeatureFlag} from './constants/signalmanConstants';

export const UNITS_QTY = 500;

const unitPriceDisplayTestFeatureFlagValues = {
  CONTROL: 'control',
  EXCLUDED: 'excluded',
  TEST: 'test'
};

const styleTypes = {
  APPAREL: 'apparel',
  NON_APPAREL: 'non-apparel'
};

const NO_MINIMUM_CATEGORY_IDS = [
  '198',
  '97',
  '99',
  '111',
  '98',
  '100',
  '385',
  '1018',
  '491'
];

export function fireUnitPriceDisplayTestAnalyticsEvent() {
  window.dataLayer.push({
    ab_test_group: unitPriceDisplayTestFeatureFlag,
    ab_test_location: 'plp catalog',
    ab_test_name: '2025 05 12 lower price on plp',
    event: 'ab_test_group'
  });
}

export function checkIsUnitPriceDisplayTestApplicable({
  categoryId,
  defaultUnitPrices,
  desiredQty,
  styleType
}) {
  if (
    !styleType ||
    !desiredQty ||
    !defaultUnitPrices ||
    NO_MINIMUM_CATEGORY_IDS.includes(categoryId)
  ) {
    return false;
  }

  const hasSupportedUnitPrice = defaultUnitPrices.some(
    (dup) =>
      dup?.algorithm === DEFAULT_PRICING_ALGORITHM &&
      dup?.quantity === desiredQty &&
      Boolean(dup?.price)
  );
  return (
    hasSupportedUnitPrice &&
    styleType === styleTypes.APPAREL &&
    unitPriceDisplayTestFeatureFlag ===
      unitPriceDisplayTestFeatureFlagValues.TEST
  );
}
